/** Display format aligned with mobile readable branch (en-GB). */
export function formatDateDisplay(dateString: string): string {
  if (!dateString) return "";
  const date = parseIsoDate(dateString);
  if (!date) return dateString;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function toIsoDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseIsoDate(iso: string): Date | undefined {
  if (!iso) return undefined;
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

/** A local Date whose calendar fields represent today in the student's timezone. */
export function calendarTodayInTimeZone(timeZone?: string | null): Date {
  return parseIsoDate(todayIsoInTimeZone(timeZone)) ?? new Date();
}
import { todayIsoInTimeZone } from "@repo/doubts-utils";
